<div class="white content" [@fadeIn]="displayValueAbs" [@fadeOut]="value" (@fadeOut.done)="onFadeOutDone()">
    <span class="inline-block" [class]="valueClass">
        @if (prefixImg) {
            <img [src]="'assets/icon/' + prefixImg" alt="" [class]="imgClass ? imgClass : suffixClass" />
        }
        @if (
            displayValueAbs ||
            (displayValueAbs === 0 && displaySuffix === '%') ||
            (displayValueAbs === 0 && autorizeZero)
        ) {
            <span
                [class.medium]="+displayValueAbs >= 1000 || (+displayValueAbs >= 100 && hasDecimalAndBigUnit)"
                [class.small]="+displayValueAbs >= 10000 || (+displayValueAbs >= 1000 && hasDecimalAndBigUnit)"
                [class.extra-small]="+displayValueAbs >= 100000 || (+displayValueAbs >= 10000 && hasDecimalAndBigUnit)"
                >{{ displayValue }}</span
            >
        }
    </span>
    <span [class]="suffixClass">{{ displaySuffix }}</span>
    @if (exponentContent) {
        <sup [class]="valueClassExponent">{{ exponentContent }}</sup>
    }
</div>
